module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_orl_4d3e6fc.png";